import type { ColumnDef } from '@/components/ui';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { IIssueInProgressDaily } from '@skystone/shared';
import { issueInProgressDailyApi } from '@/services/issue-in-progress-daily-api';
import { useApi } from '@/hooks/useApi';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const issueInProgressDailyColumns: ColumnDef<IIssueInProgressDaily>[] = buildRawColumns<IIssueInProgressDaily>([
  { key: 'id', header: 'ID' },
  { key: 'snapshotDate', header: 'Snapshot Date' },
  { key: 'issueKey', header: 'Issue Key' },
  { key: 'issueType', header: 'Issue Type' },
  { key: 'inProgressFlag', header: 'In Progress Flag' },
  { key: 'teamId', header: 'Team ID' },
  { key: 'teamName', header: 'Team Name' },
  { key: 'productId', header: 'Product ID' },
  { key: 'productName', header: 'Product Name' },
  { key: 'fabricTeamId', header: 'Fabric Team ID' },
  { key: 'archived', header: 'Archived' },
  { key: 'archivedAt', header: 'Archived At' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function IssueInProgressDailyPage() {
  const { data: rows, loading, error } = useApi(() => issueInProgressDailyApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader
        title="Tbl - issue_in_progress_daily"
        subtitle={buildStandardTblSubtitle()}
      />

      <ErrorBanner message={error} />

      <DataTable
        data={rows ?? []}
        columns={issueInProgressDailyColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('issue in-progress daily')}
      />
    </PageContainer>
  );
}
